import React from 'react';
import ClientPage from '../../@common/hoc/ClientPage/index';
import asyncComponent from '../../@common/utility/asyncComponent';

const PostDetails = asyncComponent(
  () => import('../../modules/clients/LawDissemination/PostDetails'),
  true,
);
export default ClientPage(() => <PostDetails />);
